// Mock data for SimplifyMyTraining.com style trainer profiles

export const trainerProfileMock = {
  id: "1",
  basicInfo: {
    name: "Dr. Sarah Johnson",
    firstName: "Sarah",
    location: "New York",
    profileImage: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=200&h=200&fit=crop&crop=face",
    organization: "TrainingCorp Solutions Pvt. Ltd."
  },
  
  contact: {
    phone: "+1 (555) 123-4567",
    email: "sarah.johnson@trainingcorp.com",
    linkedin: "linkedin.com/in/sarah-johnson-trainer",
    website: "www.sarahjohnsontraining.com",
    address: {
      street: "123 Training Avenue",
      city: "New York",
      state: "NY",
      zipCode: "10001",
      country: "USA"
    },
    socialMedia: {
      twitter: "@SarahJTrainer",
      facebook: "SarahJohnsonTraining",
      instagram: "@sarahtraining"
    }
  },

  education: [
    {
      id: "1",
      degree: "Ph.D. in Organizational Psychology",
      institution: "Harvard University",
      location: "Cambridge, MA",
      startDate: "2012",
      endDate: "2016",
      details: "Dissertation: 'Impact of Transformational Leadership on Employee Learning and Development'",
      gpa: "3.9/4.0"
    },
    {
      id: "2", 
      degree: "Master of Science in Adult Learning & Development",
      institution: "Columbia University",
      location: "New York, NY",
      startDate: "2010",
      endDate: "2012",
      details: "Specialization in Corporate Training and Development",
      gpa: "3.8/4.0"
    },
    {
      id: "3",
      degree: "Bachelor of Arts in Psychology",
      institution: "Stanford University", 
      location: "Stanford, CA",
      startDate: "2006",
      endDate: "2010",
      details: "Magna Cum Laude, Phi Beta Kappa Honor Society",
      gpa: "3.7/4.0"
    }
  ],

  workExperience: [
    {
      id: "1",
      title: "Senior Corporate Training Specialist",
      company: "Microsoft Corporation",
      location: "Seattle, WA",
      startDate: "January 2020",
      endDate: "Present",
      duration: "4+ years",
      summary: "Lead comprehensive training programs for 500+ employees across multiple departments",
      details: [
        "Designed and delivered leadership development programs for C-suite executives",
        "Implemented microlearning initiatives resulting in 40% improvement in knowledge retention",
        "Managed annual training budget of $2.5M across global operations",
        "Conducted train-the-trainer sessions for 50+ internal facilitators",
        "Developed virtual reality training modules for technical skills development"
      ],
      achievements: [
        "Increased employee satisfaction scores by 35%",
        "Reduced training costs by 25% while improving outcomes",
        "Recognized as 'Trainer of the Year' 2022 & 2023"
      ]
    },
    {
      id: "2",
      title: "Learning & Development Manager",
      company: "Amazon Web Services",
      location: "Austin, TX", 
      startDate: "March 2018",
      endDate: "December 2019",
      duration: "1 year 10 months",
      summary: "Developed and implemented comprehensive L&D strategies for cloud services division",
      details: [
        "Created certification programs for cloud computing technologies",
        "Managed team of 12 training professionals across 3 regions",
        "Established partnerships with 15+ educational institutions",
        "Launched AWS Skills Builder platform for continuous learning"
      ],
      achievements: [
        "Achieved 95% certification pass rate across all programs",
        "Increased internal promotion rate by 28%"
      ]
    },
    {
      id: "3",
      title: "Senior Training Consultant",
      company: "Deloitte Consulting",
      location: "Chicago, IL",
      startDate: "June 2016", 
      endDate: "February 2018",
      duration: "1 year 8 months",
      summary: "Provided strategic training solutions for Fortune 500 clients",
      details: [
        "Delivered change management training for organizational transformations",
        "Designed custom leadership development curricula",
        "Facilitated executive coaching sessions",
        "Conducted training needs assessments and ROI analysis"
      ],
      achievements: [
        "Generated $3.2M in training revenue",
        "Maintained 98% client satisfaction rating"
      ]
    }
  ],

  trainingExperience: [
    {
      id: "1",
      programName: "Leadership Excellence Masterclass",
      targetAudience: "C-Level Executives",
      duration: "3 days intensive",
      participantCount: "200+",
      deliveryMode: "In-person & Virtual",
      topics: ["Strategic Leadership", "Change Management", "Team Building", "Decision Making"],
      frequency: "Quarterly",
      yearsDelivered: "5 years"
    },
    {
      id: "2",
      programName: "Digital Transformation Training",
      targetAudience: "Middle Management",
      duration: "2 days workshop",
      participantCount: "500+",
      deliveryMode: "Hybrid",
      topics: ["Technology Adoption", "Process Optimization", "Digital Mindset", "Innovation"],
      frequency: "Monthly",
      yearsDelivered: "3 years"
    },
    {
      id: "3",
      programName: "Train-the-Trainer Certification",
      targetAudience: "Internal Trainers",
      duration: "5 days program",
      participantCount: "150+",
      deliveryMode: "In-person",
      topics: ["Adult Learning Principles", "Facilitation Skills", "Assessment Design", "Training Delivery"],
      frequency: "Bi-annually", 
      yearsDelivered: "6 years"
    },
    {
      id: "4",
      programName: "Soft Skills Development Bootcamp",
      targetAudience: "New Employees",
      duration: "1 day workshop",
      participantCount: "1000+",
      deliveryMode: "Virtual",
      topics: ["Communication", "Time Management", "Emotional Intelligence", "Collaboration"],
      frequency: "Weekly",
      yearsDelivered: "4 years"
    }
  ],

  inAction: {
    videos: [
      {
        id: "1",
        title: "Leadership in Crisis: A Masterclass",
        description: "Dr. Johnson delivering a keynote on crisis leadership during the pandemic",
        url: "https://www.youtube.com/embed/dQw4w9WgXcQ",
        duration: "45 minutes",
        views: "12,500",
        date: "March 2023"
      },
      {
        id: "2", 
        title: "Virtual Training Best Practices",
        description: "Workshop demonstration on engaging remote learners",
        url: "https://www.youtube.com/embed/dQw4w9WgXcQ",
        duration: "30 minutes", 
        views: "8,200",
        date: "January 2023"
      }
    ],
    presentations: [
      {
        id: "1",
        title: "Future of Corporate Learning",
        event: "Learning Technologies Conference 2023",
        location: "Las Vegas, NV",
        date: "October 2023",
        audienceSize: "500+",
        description: "Keynote presentation on emerging trends in corporate training"
      },
      {
        id: "2",
        title: "ROI of Leadership Development", 
        event: "ATD International Conference",
        location: "Denver, CO",
        date: "May 2023",
        audienceSize: "300+",
        description: "Data-driven approach to measuring training effectiveness"
      }
    ],
    mediaFeatures: [
      {
        id: "1",
        publication: "Training Industry Magazine",
        title: "Top 40 Training Professionals Under 40",
        date: "August 2023",
        type: "Feature Article"
      },
      {
        id: "2",
        publication: "Harvard Business Review",
        title: "The Science of Effective Leadership Training",
        date: "June 2023", 
        type: "Guest Article"
      }
    ]
  },

  testimonials: [
    {
      id: "1",
      clientName: "Michael Chen",
      clientTitle: "VP of Operations",
      company: "TechGlobal Inc.",
      rating: 5,
      date: "November 2023",
      testimonial: "Dr. Johnson's leadership training transformed our entire management team. Her practical approach and deep expertise made complex concepts accessible. We saw immediate improvements in team performance and employee engagement.",
      programAttended: "Leadership Excellence Masterclass"
    },
    {
      id: "2",
      clientName: "Lisa Rodriguez",
      clientTitle: "Chief Human Resources Officer", 
      company: "InnovateCorp",
      rating: 5,
      date: "September 2023",
      testimonial: "Outstanding facilitator with exceptional ability to customize content to our specific needs. Sarah's digital transformation training helped our organization successfully navigate major technology changes with minimal disruption.",
      programAttended: "Digital Transformation Training"
    },
    {
      id: "3",
      clientName: "David Thompson",
      clientTitle: "Learning & Development Director",
      company: "MegaBank Solutions", 
      rating: 5,
      date: "August 2023",
      testimonial: "The train-the-trainer certification program exceeded our expectations. Sarah equipped our internal trainers with cutting-edge methodologies and practical tools. ROI was evident within the first quarter.",
      programAttended: "Train-the-Trainer Certification"
    },
    {
      id: "4",
      clientName: "Jennifer Wang",
      clientTitle: "Regional Manager",
      company: "Global Logistics Ltd.",
      rating: 5,
      date: "July 2023", 
      testimonial: "Engaging, knowledgeable, and results-driven. Dr. Johnson's soft skills bootcamp significantly improved our team's communication and collaboration. Highly recommend her services.",
      programAttended: "Soft Skills Development Bootcamp"
    }
  ],

  preferences: {
    trainingMethods: [
      "Interactive Workshops",
      "Experiential Learning", 
      "Case Study Analysis",
      "Role-Playing Exercises",
      "Group Discussions",
      "Simulation-Based Training",
      "Blended Learning Approach"
    ],
    industriesServed: [
      "Technology",
      "Financial Services", 
      "Healthcare",
      "Manufacturing",
      "Consulting",
      "Retail",
      "Government"
    ],
    specializations: [
      "Leadership Development",
      "Change Management",
      "Digital Transformation",
      "Team Building",
      "Executive Coaching",
      "Train-the-Trainer",
      "Soft Skills Development",
      "Performance Management"
    ],
    deliveryModes: [
      "In-Person Training",
      "Virtual/Online Training",
      "Hybrid Training",
      "One-on-One Coaching", 
      "Group Facilitation",
      "Keynote Speaking"
    ],
    languages: [
      "English (Native)",
      "Spanish (Conversational)",
      "French (Basic)"
    ],
    availability: {
      fullTime: false,
      partTime: true,
      freelance: true,
      consulting: true,
      travel: "Willing to travel domestically and internationally"
    },
    ratesAndPackages: {
      dayRate: "$2,500 - $5,000",
      halfDayRate: "$1,500 - $3,000", 
      keynoteSpeaking: "$5,000 - $15,000",
      consultingHourly: "$200 - $400",
      customPrograms: "Quote on request"
    }
  },

  certifications: [
    {
      id: "1",
      name: "Certified Professional in Learning and Performance (CPLP)",
      issuingOrganization: "Association for Talent Development (ATD)",
      issueDate: "2017",
      expiryDate: "2026",
      credentialId: "CPLP-2017-4789"
    },
    {
      id: "2",
      name: "Certified Executive Coach", 
      issuingOrganization: "International Coach Federation (ICF)",
      issueDate: "2018",
      expiryDate: "2025",
      credentialId: "ICF-PCC-2018-1234"
    },
    {
      id: "3",
      name: "Train the Trainer Master Certification",
      issuingOrganization: "Training Industry Inc.",
      issueDate: "2016",
      expiryDate: "Never expires",
      credentialId: "TTT-MC-2016-5678"
    }
  ],

  awards: [
    {
      id: "1",
      title: "Trainer of the Year",
      organization: "Microsoft Corporation",
      year: "2023",
      description: "Recognized for outstanding contribution to employee development"
    },
    {
      id: "2",
      title: "Excellence in Learning Innovation",
      organization: "Learning Technologies Awards",
      year: "2022",
      description: "For pioneering VR-based training methodologies"
    }
  ]
};